/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleWithRelations } from './roleWithRelations';
import { UserWithRelations } from './userWithRelations';
import { TenantWithRelations } from './tenantWithRelations';


/**
 * (tsType: UserTenantWithRelations, schemaOptions: { includeRelations: true })
 */
export interface UserTenantWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    id?: number;
    userId: number;
    tenantId: number;
    roleId: number;
    status: string;
    user?: UserWithRelations;
    tenant?: TenantWithRelations;
    role?: RoleWithRelations;
}

